import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-2v1',
  templateUrl: './2v1.component.html',
})
export class CuiGeneral2v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
